"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledComponentsModifiers = require("styled-components-modifiers");

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _dimensions = _interopRequireWildcard(require("../../../modifiers/dimensions"));

var _display = _interopRequireWildcard(require("../../../modifiers/display"));

var _spacing2 = _interopRequireWildcard(require("../../../modifiers/spacing"));

var _modifiers = require("./modifiers");

var _schema = _interopRequireDefault(require("./schema"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Column = _styledComponents.default.div.withConfig({
  displayName: "Column",
  componentId: "sc-1setzzp-0"
})(["box-sizing:border-box;display:block;flex-basis:0;flex-grow:1;max-width:100%;padding-left:", ";padding-right:", ";position:relative;", ";", ";", ";", ";", ";"], (0, _rem.default)(_spacing.default.base), (0, _rem.default)(_spacing.default.base), _modifiers.offsetModifiers, _modifiers.spanModifiers, _dimensions.default, _display.default, _spacing2.default); // @ts-ignore


Column.propTypes = _objectSpread({}, _schema.default.propTypes, {
  offset: (0, _styledComponentsModifiers.styleModifierPropTypes)(_modifiers.offsetModifiersConfig),
  span: (0, _styledComponentsModifiers.styleModifierPropTypes)(_modifiers.spanModifiersConfig)
}, _dimensions.dimensionPropTypes, {}, _display.displayPropTypes, {}, _spacing2.spacingPropTypes);
Column.displayName = 'Grid.Column';
var _default = Column;
exports.default = _default;